import { TextField } from "@mui/material";
import { useState } from "react";
import Modal from "../ui/Modal";
import FormItem from "../ui/FormItem";
import { createInstitution, editInstitution } from "../../api";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { DropzoneArea } from "mui-file-dropzone";

const AddInstitution = ({ data, refresh, ...props }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        logo: null,
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleLogoUpload = (files) => {
        if (files && files.length > 0) {
            const logoUrl = URL.createObjectURL(files[0]);
            setFormData({
                ...formData,
                logo: logoUrl,
            });
        } else {
            setFormData({
                ...formData,
                logo: null,
            });
        }
    };

    const handleSubmit = () => {
        setLoading(true);
        const submit = data ? editInstitution : createInstitution;
        submit(formData)
            .then((_) => {
                enqueueSnackbar(`Institution ${data ? "edited" : "added"}.`, {
                    variant: "success",
                });
                refresh();
                props.close();
            })
            .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (data) {
            setFormData(data);
        } else {
            setFormData({
                name: "",
                logo: null,
            });
        }
    }, [data]);

    return (
        <Modal
            {...props}
            title={`${data ? "Edit" : "Add"} Institution`}
            actionText={data ? "Edit" : "Add"}
            action={handleSubmit}
            loading={loading}
        >
            <FormItem label="Name of institution">
                <TextField
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                />
            </FormItem>
            <FormItem label="Upload Logo">
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={["image/*"]}
                    useChipsForPreview
                    dropzoneText="Drag and drop an image or click here"
                    onChange={handleLogoUpload}
                />
            </FormItem>
        </Modal>
    );
};

export default AddInstitution;
